import React, { createContext, useContext, useEffect, useState } from 'react';

/* Contexte licence portail : expose les modules / intégrations / options souscrits
 * (depuis /api/sso/context) pour le gating d'affichage (masquer ce qui n'est pas
 * souscrit). Fail-open volontaire : tant que non chargé, ou pour une session
 * locale NON-SSO (pas de licence portail à appliquer), on ne masque rien. */

const LicenseContext = createContext(null);

export const useLicense = () => useContext(LicenseContext) || {
  loaded: false, sso: null,
  hasModule: () => true, hasIntegration: () => true, hasOption: () => true,
};

export const LicenseProvider = ({ children }) => {
  const [sso, setSso] = useState(null);

  useEffect(() => {
    let alive = true;
    fetch('/api/sso/context')
      .then(r => r.json())
      .then(d => { if (alive) setSso(d); })
      .catch(() => { if (alive) setSso({ connected: false }); });
    return () => { alive = false; };
  }, []);

  // On ne restreint que si l'utilisateur est bien connecté via le portail (SSO).
  const gate = (list) => (code) => {
    if (!sso || !sso.connected) return true; // pas chargé / session locale -> tout visible
    return (list || []).includes(code);
  };

  const value = {
    loaded: !!sso,
    sso,
    hasModule: gate(sso && sso.modules),
    hasIntegration: gate(sso && sso.integrations),
    hasOption: gate(sso && sso.options),
  };

  return <LicenseContext.Provider value={value}>{children}</LicenseContext.Provider>;
};
